module.exports = __webpack_public_path__ + "static/media/lb.75bcf51a.svg";